import React from "react";
import {
  Box,
  Container,
  Divider,
  Grid,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import SectionTitle from "./SectionTitle";
import { experience } from "./homeData";

export default function ExperienceSection() {
  const theme = useTheme();

  return (
    <Box component="section" py={10} bgcolor={theme.palette.background.paper}>
      <Container>
        <SectionTitle
          eyebrow="Experience"
          title="A journey through product, design, and engineering"
          subtitle="Blending customer empathy with technical execution across roles to deliver outcomes, not just features."
        />
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Stack spacing={4}>
              {experience.map((item, index) => (
                <Box
                  key={item.period}
                  sx={{
                    p: 3,
                    borderRadius: "18px",
                    border: "1px solid rgba(15, 23, 42, 0.08)",
                    background: index % 2 === 0 ? "rgba(99,102,241,0.05)" : "rgba(15, 23, 42, 0.02)",
                    boxShadow: "0 18px 36px rgba(15, 23, 42, 0.08)",
                  }}
                >
                  <Typography variant="overline" sx={{ letterSpacing: 1.5, fontWeight: 600 }}>
                    {item.period}
                  </Typography>
                  <Typography variant="h3" component="h3" sx={{ fontWeight: 600, mt: 1 }}>
                    {item.role}
                  </Typography>
                  <Typography variant="body1" color="text.secondary" sx={{ mt: 1.5 }}>
                    {item.summary}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                height: "100%",
                borderRadius: "24px",
                p: 4,
                background: `linear-gradient(135deg, ${theme.palette.primary.main}0c, ${theme.palette.secondary.main}1f)`,
                border: "1px solid rgba(99, 102, 241, 0.2)",
                boxShadow: "0 24px 48px rgba(79, 70, 229, 0.18)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                gap: 3,
              }}
            >
              <Stack spacing={2}>
                <Typography variant="h3" component="h3" sx={{ fontWeight: 600 }}>
                  How I collaborate
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  I listen, map user journeys, prototype quickly, and iterate with data. Accessibility, motion, and micro-interactions are not afterthoughts-they are core to the story.
                </Typography>
              </Stack>
              <Divider sx={{ borderColor: "rgba(79, 70, 229, 0.25)" }} />
              <Stack spacing={2}>
                <Typography variant="h4" component="h4" sx={{ fontWeight: 600 }}>
                  What teammates say
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  &quot;Krushna brings a calm, strategic voice to complex challenges and always champions the user. He makes the hard things feel joyful.&quot;
                </Typography>
                <Typography variant="subtitle2" color="text.secondary">
                  Product Design Lead - 2023
                </Typography>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
